
import './style.scss';
import { Delete, Fullscreen, InsertDriveFile } from '@mui/icons-material';
import FileHelper from '../../helpers/FileHelper';
import { Box, Button, Typography } from '@mui/material';
import { useMemo } from 'react';


interface IAttachmentCardProps {
    link: string;
    name: string;
    size?: 'small' | 'medium' | 'large';
    hoverAction?: 'remove' | 'fullscreen';
    className?: string;
    onClick?: () => void;
}


const AttachmentCard: React.FC<IAttachmentCardProps> = ({
    link,
    name,
    size = 'medium',
    hoverAction = undefined,
    className = '',
    onClick = () => {}
}) => {
    const hoverActionBackdrop = useMemo(() => {
        const attachmentCardAttr = {
            className: '',
            Icon: <></>
        };

        if (hoverAction === 'remove') {
            attachmentCardAttr.className = `color-red`;
            attachmentCardAttr.Icon = <Delete className='attachmentcard-backdrop-icon' />;
        }

        if (hoverAction === 'fullscreen') {
            attachmentCardAttr.Icon = <Fullscreen className='attachmentcard-backdrop-icon' />;
        }

        return <Button className={`attachmentcard-backdrop ${attachmentCardAttr.className}`} onClick={onClick}>
            {attachmentCardAttr.Icon}
        </Button>;
    }, [hoverAction, onClick]);


    const content = useMemo(() => {
        if (FileHelper.IsImage(name)) {
            return null;
        }

        if (FileHelper.IsVideo(name)) {
            return <video 
                controls={hoverAction === undefined} 
                src={link} 
                className='attachmentcard-video' 
            />;
        }

        return <>
            <InsertDriveFile className='attachmentcard-icon' />
            
            <Typography className='attachmentcard-name'>
                {name}
            </Typography>
        </>;
    }, [name, link, hoverAction]);


    // Check if is video to apply new classnames
    if (FileHelper.IsVideo(name)) {
        className = `${className} type-video`;
    }

    return <Box 
        className={`attachmentcard-default ${size} ${className}`}
        onClick={hoverAction === 'remove' ? undefined : onClick}
        sx={{
            backgroundImage: `url(${link})`
        }}
    >
        {content}

        {hoverAction !== undefined && hoverActionBackdrop}
    </Box>;
}

export default AttachmentCard;